
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getEditoriales } from '../services/editorialService';


function MyCarousel() {
  const [editoriales, setEditoriales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchEditoriales = async () => {
      try {
        const data = await getEditoriales();
        setEditoriales(data.slice(0, 3));
      } catch (error) {
        console.error('Error al cargar las editoriales:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEditoriales();
  }, []);

  // Auto-avance cada 5 segundos
  useEffect(() => {
    if (editoriales.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % editoriales.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [editoriales.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + editoriales.length) % editoriales.length);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % editoriales.length);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '500px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando editoriales...</span>
        </div>
      </div>
    );
  }

  if (editoriales.length === 0) {
    return (
      <div className="alert alert-info m-4">
        No hay editoriales disponibles en este momento.
      </div>
    );
  }

  const currentEditorial = editoriales[currentIndex];

  return (
    <div className="carousel-container position-relative shadow-sm" style={{ minHeight: '500px', backgroundColor: '#fdfdfd' }}>
      {/* Slide actual con transición */}
      <div className="slide-bg d-flex align-items-center" style={{ minHeight: '550px' }}>
        <div className="container py-5">
          <div className="row align-items-center">
            {/* Columna izquierda: imagen */}
            <div className="carousel-image col-md-6 mb-4 mb-md-0">
              <div style={{
              backgroundColor: '#f1f1f1', // Fondo por si la imagen es pequeña
                borderRadius: '15px',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '400px' // Altura fija para que el carrousel no salte
              }}>
              {currentEditorial.imagen ? (
                <img
                  src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}${currentEditorial.imagen}`}
                  className="img-fluid rounded"
                  alt={currentEditorial.titulo}
                  style={{ 
                    maxHeight: '100%',
                    maxWidth: '100%' ,
                    objectFit: 'contain', 
                    transition: 'opacity 0.5s ease-in-out'
                  }}
                />
              ) : (
                <div className="text-muted">Sin imagen disponible</div>
              )}
            </div>
          </div>

            {/* Columna derecha: texto */}
            <div className="carousel-content col-md-6 text-center text-md-start ps-md-5">
              <h2 className="display-5 fw-bold" style={{ color:' #eeeded' , marginBottom: '20px' }}>
                {currentEditorial.titulo}
              </h2>
              <p className="text-uppercase fw-semibold text-muted" style={{ letterSpacing: '1px', fontSize: '0.9rem' }}>
                 Por <span style={{ color: 'white' }}> {currentEditorial.autor} </span> |  {new Date(currentEditorial.fechaPublicacion).toLocaleDateString('es-AR', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
              {currentEditorial.bajada && (
                <p className="lead mb-4" style={{ color: '#eeeded' }}>
                {currentEditorial.bajada}
                </p>
              )}
              <div className="mt-4">
                <Link
                  className="btn btn-lg px-5"
                  to={`/editoriales/${currentEditorial.id}`}
                  style={{ 
                    backgroundColor: '#434242', 
                    color: 'white',
                    fontSize: '1rem',
                    fontWeight: '600',
                    transition: 'transform 0.2s'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                >
                  Seguir Leyendo
                </Link>
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* Controles - Solo mostrar si hay más de 1 editorial */}
      {editoriales.length > 1 && (
        <>
          {/* Botón Anterior */}
          <button 
            onClick={goToPrevious}
            className="d-none d-md-block position-absolute top-50 start-0 translate-middle-y btn bg-transparent border-0 ms-3"
            style={{ zIndex: 10, color: 'white', fontSize: '2.5rem', transition: 'transform 0.2s ease-in-out' }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.20)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
            aria-label="Anterior"
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          {/* Botón Siguiente */}
          <button 
            onClick={goToNext}
            className="d-none d-md-block position-absolute top-50 end-0 translate-middle-y btn bg-transparent border-0 ms-3"
            style={{ zIndex: 10, color: 'white', fontSize: '2.5rem', transition: 'transform 0.2s ease-in-out'  }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.20)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
            aria-label="Siguiente"
          >
            <i className="bi bi-chevron-right"></i>
          </button>

          {/* Indicadores */}
        <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4 d-flex gap-2">
            {editoriales.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className="border-0"
                style={{
                  width: '30px',
                  height: '4px',
                  backgroundColor: index === currentIndex ? '#1a1a1a' : '#dee2e6',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default MyCarousel;